import es from './es'

export default {
  es: es,
  ES: es
}
